module.exports = __webpack_public_path__ + "static/media/lp2.26f38175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp2.jpg
// module id = 670
// module chunks = 31